import type { ISelectActions, IRenderFieldOptions } from './models';

export const getCurrentIndex = (options: IRenderFieldOptions[], inputValue: string) =>
    options.findIndex(({ label }) => label === inputValue);

/** Если индекс не последний - увеличить */
export const getDownIndex = (options: IRenderFieldOptions[], highlightedItem: number) =>
    Math.min(highlightedItem + 1, options.length - 1);

/** Если индекс не минимальный - уменьшить */
export const getUpIndex = (highlightedItem: number, readOnly?: boolean) =>
    Math.max(highlightedItem - 1, readOnly ? 0 : -1);

/** Рассчитать положение дропдауна */
export const getDropdownPosition = ({ autocompleteRef, inputRef }: ISelectActions['refs']) => {
    if (!autocompleteRef.current || !inputRef.current) {
        return 'bottom';
    }
    // visualViewport нужен для определения корректной высоты на ios с экранной клавиатурой
    const clientHeight = window.visualViewport?.height || document.documentElement.clientHeight;

    const { bottom, height, top } = inputRef.current.getBoundingClientRect();
    const dropDownHeight = autocompleteRef.current.getBoundingClientRect().height;

    return top + height + dropDownHeight > clientHeight && top > clientHeight - bottom
        ? 'top'
        : 'bottom';
};
